const recentEvents = new Map();
const DUPLICATE_WINDOW_MS = 1000;
const SENSITIVE_PARAMETER_KEY =
  /^(email|email_address|phone|telephone|contact_number|name|filename|file_name|message|message_body|user_id|rfq_details)$/i;

function hasAnalytics() {
  return (
    typeof window !== "undefined" &&
    typeof window.gtag === "function" &&
    Boolean(window.__wibitecAnalyticsConfigured)
  );
}

function getEventFingerprint(eventName, parameters) {
  const orderedParameters = Object.keys(parameters)
    .sort()
    .reduce((result, key) => {
      result[key] = parameters[key];
      return result;
    }, {});

  return `${eventName}:${JSON.stringify(orderedParameters)}`;
}

function removeSensitiveParameters(parameters) {
  return Object.entries(parameters).reduce((result, [key, value]) => {
    if (!SENSITIVE_PARAMETER_KEY.test(key)) {
      result[key] = value;
    }
    return result;
  }, {});
}

/**
 * Sends a non-sensitive GA4 event when analytics is available.
 * Intentionally fails silently when blocked or unavailable.
 */
export function trackEvent(eventName, parameters = {}) {
  if (typeof eventName !== "string" || !eventName.trim() || !hasAnalytics()) {
    return;
  }

  try {
    const safeParameters = removeSensitiveParameters(
      parameters && typeof parameters === "object" ? parameters : {},
    );
    const fingerprint = getEventFingerprint(eventName.trim(), safeParameters);
    const now = Date.now();
    const lastSentAt = recentEvents.get(fingerprint);

    // Avoid obvious React Strict Mode duplicates while allowing later visits.
    if (lastSentAt && now - lastSentAt < DUPLICATE_WINDOW_MS) {
      return;
    }

    recentEvents.set(fingerprint, now);
    window.gtag("event", eventName.trim(), safeParameters);
  } catch {
    // Analytics must never affect site functionality.
  }
}
